import { useParams, Link, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { journal } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function JournalEntry() {
    const { slug } = useParams();
    const entry = journal.find((j) => j.slug === slug);
    if (!entry) return <Navigate to="/journal" replace />;

    return (
        <article data-testid="page-journal-entry" className="bg-forest-950 text-ivory">
            <section className="relative min-h-[60vh] md:min-h-[75vh] overflow-hidden">
                <img src={entry.cover} alt={entry.title} className="absolute inset-0 h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-b from-forest-950/50 to-forest-950" />
                <div className="relative mx-auto max-w-[1440px] px-6 md:px-10 pt-40 md:pt-48 pb-20 flex flex-col justify-end min-h-[60vh] md:min-h-[75vh]">
                    <Link to="/journal" data-testid="back-to-journal" className="inline-flex items-center gap-3 font-mono-mini text-[10px] tracking-[0.32em] uppercase text-ivory/70 hover:text-lime mb-10 w-fit">
                        <ArrowLeft size={14} /> Journal
                    </Link>
                    <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime mb-4">
                        Chapter {entry.chapter} · {entry.date} · {entry.readTime}
                    </div>
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1.1, ease: EASE }}
                        className="font-serif-display leading-[1.02] tracking-tight text-ivory text-[2.4rem] md:text-[4.5rem] max-w-4xl"
                    >
                        {entry.title}
                    </motion.h1>
                </div>
            </section>

            <section className="mx-auto max-w-3xl px-6 md:px-10 py-20 md:py-28 text-ivory/85 space-y-6 text-[1.05rem] leading-[1.85]">
                <p className="font-serif-display italic text-2xl text-ivory/90">
                    In 2007, we made ourselves a promise. Fewer projects. Longer time. More care.
                </p>
                <p>
                    Eighteen years on, the number we have delivered is thirty-seven. That is
                    roughly two projects a year. It is not a lot. It is on purpose.
                </p>
                <p>
                    Slowness is not a luxury we sell. It is the operating cost of doing the
                    detail right. Of pouring concrete once — properly. Of laying stone by hand.
                    Of letting the landscape settle before we hand over keys.
                </p>
                <p>
                    We think it makes better buildings. Buildings that get better as they age.
                    That is the only measure that matters to us, in the end.
                </p>
                <div className="pt-8 border-t border-white/10 text-ivory/50 text-sm">
                    — Ar. Devika Rao, Founding Principal
                </div>
            </section>
        </article>
    );
}
